<!-- @format -->

<div class="clear">
  <ul class="tree-list tree-list-study-plan clearfix">
    <li class="{{ classes }}">
      <div
        class="module-border"
        [class.collapsed]="!isOpen"
        [class.module-border-selected]="uiStateObject.selectedModule?.id === module.id">
        <div class="tree-list-heading tree-list-heading-has-children clearfix no-padding">
          <div
            class="accordion-panel accordion-panel-long-title"
            [class.accordion-panel-primary]="uiStateObject.selectedModule?.id === module.id"
            [class.accordion-panel-noblock]="uiStateObject.selectedModule?.id !== module.id"
            [class.clickable]="!moduleStateObject.attainmentId"
            [class.highlighted]="highlighted">
            <div class="header has-header-items">
              <button
                type="button"
                class="collapse non-button"
                (click)="isOpen = !isOpen"
                [class.collapsed]="!isOpen"
                [class.disabled]="isImplicit"
                [attr.aria-expanded]="isOpen"
                [attr.aria-label]="module.name | localizedString">
                <sis-icon icon="chevron-ring-fill" [iconClass]="isOpen ? 'cw-90' : null"></sis-icon>
              </button>
              @if (moduleStateObject.studyRightState) {
                <sis-icon icon="junction"></sis-icon>
                <span class="visually-hidden" translate>ARIA_LABEL.STUDY_RIGHT</span>
              }
              <div class="title" (click)="handleModuleHeaderClick()">
                <span class="plan-module-name">{{ module.name | localizedString }}</span>
                <span class="additional">
                  @if (moduleStateObject.isAttainmentAboutToExpire) {
                    <span class="tiny-badge accent">
                      <span translate>PLAN.MODULE.EXPIRATION_IMMINENT</span>
                      {{ moduleStateObject.attainmentExpiryDate | localDateFormat }}
                    </span>
                  }
                  @if (moduleStateObject.invalidSelection && moduleStateObject.hasModuleContentApproval) {
                    <span class="tiny-badge danger">
                      <span translate>PLAN.INVALID_SELECTIONS.NOTIFICATION</span>
                    </span>
                  }
                  @if (moduleStateObject.invalidSelectionAccordingToModuleContentApproval) {
                    <span class="tiny-badge danger">
                      <span translate>PLAN.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL.NOTIFICATION</span>
                    </span>
                  }
                  @if (module.documentState === "DRAFT" || module.documentState === "DELETED") {
                    <span
                      class="tiny-badge"
                      [class.accent]="module.documentState === 'DRAFT'"
                      [class.danger]="module.documentState === 'DELETED'"
                      [translate]="'VISIBLE_DOCUMENT_STATE.' + module.documentState">
                    </span>
                  }
                  {{ module.code }}
                  @if (moduleStateObject.studyRightState) {
                    <span>
                      | <span>{{ "PLAN_STUDY_RIGHT_STATE." + moduleStateObject.studyRightState | translate }}</span>
                    </span>
                  }
                </span>
              </div>
              @if (isImplicit) {
                <div class="cell info-box">
                  <div><sis-icon icon="info"></sis-icon></div>
                  <div class="info-text">{{ "PLAN.MODULE.IMPLICIT_IN_MODULE" | translate }} {{ parentModule.name | localizedString }}</div>
                </div>
              }
              @if (moduleStateObject.gradeAverage) {
                <div class="cell average" [class.clickable]="!moduleStateObject.attainmentId">
                  <div>{{ moduleStateObject.gradeAverage }}</div>
                </div>
              }
              <div class="cell status">
                @if (moduleStateObject.attainmentId) {
                  <div class="state-attained">
                    <span translate="SIS_COMPONENTS.PLAN_STATE.ATTAINED"></span>
                    <sis-icon icon="achievement" color="success"></sis-icon>
                    <span class="grade-text"> {{ moduleStateObject.grade.abbreviation | localizedString }} </span>
                  </div>
                }
                @if (moduleStateObject.moduleValidationResult.state !== "ATTAINED") {
                  <div class="cell status">
                    @switch (moduleStateObject.planState) {
                      @case ("INVALID") {
                        <div
                          [class.state-gray]="uiStateObject.selectedModule?.id === module.id"
                          [class.state-invalid]="uiStateObject.selectedModule?.id !== module.id">
                          <sis-icon icon="alert-fill"></sis-icon>
                          @if (moduleStateObject.planState) {
                            <span>{{ "SIS_COMPONENTS.PLAN_STATE." + moduleStateObject.planState | translate }}</span>
                          }
                        </div>
                      }
                      @case ("MODULECONTENTAPPROVAL_VALIDATION_STATE_INVALID_REQUESTED") {
                        <div
                          [class.state-gray]="uiStateObject.selectedModule?.id === module.id"
                          [class.state-invalid]="uiStateObject.selectedModule?.id !== module.id">
                          <sis-icon icon="alert-fill"></sis-icon>
                          @if (moduleStateObject.planState) {
                            <span>{{ "SIS_COMPONENTS.PLAN_STATE." + moduleStateObject.planState | translate }}</span>
                          }
                        </div>
                      }
                      @case ("MODULECONTENTAPPROVAL_VALIDATION_STATE_INVALID_ACCEPTED") {
                        <div
                          [class.state-gray]="uiStateObject.selectedModule?.id === module.id"
                          [class.state-invalid]="uiStateObject.selectedModule?.id !== module.id">
                          <sis-icon icon="alert-fill"></sis-icon>
                          @if (moduleStateObject.planState) {
                            <span>{{ "SIS_COMPONENTS.PLAN_STATE." + moduleStateObject.planState | translate }}</span>
                          }
                        </div>
                      }
                      @default {
                        <div>
                          @if (moduleStateObject.planState) {
                            <span>{{ "SIS_COMPONENTS.PLAN_STATE." + moduleStateObject.planState | translate }}</span>
                          }
                        </div>
                      }
                    }
                  </div>
                }
              </div>
              <div class="cell module-credits">
                @if (targetCredits) {
                  <sis-tooltip
                    [tooltipText]="('PROFILE.ATTAINMENT.CREDITS' | translate) + ' ' + (targetCredits | creditRange)"
                    [appendToBody]="true">
                    <div class="credit-range sis-tooltip-trigger-content">
                      <span [class.no-target-credits]="!targetCredits">
                        <span>{{ targetCredits | creditRange: "TEXT" : true }}</span>
                      </span>
                    </div>
                  </sis-tooltip>
                }
                <div class="planned-attained-credits" (click)="openModuleSelections()">
                  @if (
                    moduleStateObject.moduleValidationResult.plannedCredits &&
                    moduleStateObject.moduleValidationResult.plannedCredits.min !== 0 &&
                    moduleStateObject.moduleValidationResult.plannedCredits.max !== 0
                  ) {
                    <sis-tooltip
                      [tooltipText]="
                        ('SIS_COMPONENTS.PLAN.LABEL.SELECTED_CREDITS' | translate) +
                        ' ' +
                        (moduleStateObject.moduleValidationResult.plannedCredits | creditRange)
                      "
                      [appendToBody]="true"
                      tooltip-placement="top-right">
                      <div class="planned-credits sis-tooltip-trigger-content">
                        {{ moduleStateObject.moduleValidationResult.plannedCredits | creditRange: "TEXT" : true }}
                      </div>
                    </sis-tooltip>
                  }
                  @if (
                    !moduleStateObject.moduleValidationResult.plannedCredits ||
                    (moduleStateObject.moduleValidationResult.plannedCredits.min === 0 &&
                      moduleStateObject.moduleValidationResult.plannedCredits.max === 0)
                  ) {
                    <sis-tooltip
                      [tooltipText]="('SIS_COMPONENTS.PLAN.LABEL.SELECTED_CREDITS' | translate) + ' - ' + ('CREDITS' | translate)"
                      [appendToBody]="true"
                      tooltip-placement="top-right">
                      <div class="planned-credits sis-tooltip-trigger-content"> - </div>
                    </sis-tooltip>
                  }
                  @if (moduleStateObject.moduleValidationResult.attainedCredits) {
                    <sis-tooltip
                      [tooltipText]="
                        ('SIS_COMPONENTS.PLAN.LABEL.ATTAINED' | translate) +
                        ' ' +
                        (moduleStateObject.moduleValidationResult.attainedCredits | decimalNumber) +
                        ' ' +
                        ('CREDITS' | translate)
                      "
                      [appendToBody]="true"
                      tooltip-placement="top-left">
                      <div class="attained-credits sis-tooltip-trigger-content">
                        {{ moduleStateObject.moduleValidationResult.attainedCredits | decimalNumber }}
                      </div>
                    </sis-tooltip>
                  }
                  @if (!moduleStateObject.moduleValidationResult.attainedCredits) {
                    <sis-tooltip
                      [tooltipText]="('SIS_COMPONENTS.PLAN.LABEL.ATTAINED' | translate) + ' - ' + ('CREDITS' | translate)"
                      [appendToBody]="true"
                      tooltip-placement="top-left">
                      <div class="attained-credits sis-tooltip-trigger-content"> - </div>
                    </sis-tooltip>
                  }
                </div>
              </div>
            </div>
          </div>
          @if (!moduleStateObject.attainmentId) {
            <div>
              @if (!isImplicit && isOpen) {
                <div class="tree-list-body" [class.collapsed]="!isOpen">
                  <div class="row">
                    @for (courseUnitId of planStateObject.modules[module.id].selectedCourseUnitIds; track courseUnitId) {
                      <div class="col-sm-6 tree-list-body-inner">
                        @if (!planStateObject.courseUnits[courseUnitId].isSubstituted) {
                          <sis-plan-course-unit
                            [courseUnit]="planData.courseUnitsById[courseUnitId]"
                            [parentModule]="module"
                            [planValidationResult]="planValidationResult"
                            [planStateObject]="planStateObject"
                            [planData]="planData"></sis-plan-course-unit>
                        }
                        @if (planStateObject.courseUnits[courseUnitId].isSubstituted) {
                          <div [class.courseunit-substitution-group]="planStateObject.courseUnits[courseUnitId].substitutedBy.length > 1">
                            @for (
                              substituteCourseUnitId of planStateObject.courseUnits[courseUnitId].substitutedBy;
                              track substituteCourseUnitId
                            ) {
                              <sis-plan-course-unit
                                [courseUnit]="planData.courseUnitsById[substituteCourseUnitId]"
                                [planValidationResult]="planValidationResult"
                                [planStateObject]="planStateObject"
                                [planData]="planData"
                                [substitutedCourseUnitId]="courseUnitId"></sis-plan-course-unit>
                            }
                          </div>
                        }
                      </div>
                    }
                    @for (customStudyDraftId of planStateObject.modules[module.id].selectedCustomStudyDraftIds; track customStudyDraftId) {
                      <div class="col-sm-6 tree-list-body-inner">
                        <sis-plan-custom-study-draft
                          [customStudyDraft]="planData.customStudyDraftsById[customStudyDraftId]"></sis-plan-custom-study-draft>
                      </div>
                    }
                    @for (
                      customCourseUnitAttainmentId of planStateObject.modules[module.id].selectedCustomCourseUnitAttainmentIds;
                      track customCourseUnitAttainmentId
                    ) {
                      <div class="col-sm-6 tree-list-body-inner">
                        <sis-plan-custom-course-unit-attainment
                          [customCourseUnitAttainment]="$any(planData.attainmentsById[customCourseUnitAttainmentId])"
                          [planStateObject]="planStateObject">
                        </sis-plan-custom-course-unit-attainment>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (isOpen) {
                <div>
                  @for (moduleId of planStateObject.modules[module.id].selectedModuleIds; track moduleId) {
                    <sis-plan-module
                      [module]="planData.modulesById[moduleId]"
                      [planValidationResult]="planValidationResult"
                      [planStateObject]="planStateObject"
                      [planData]="planData"
                      [uiStateObject]="uiStateObject"
                      [isImplicit]="false"
                      [level]="level + 1">
                    </sis-plan-module>
                  }
                  @for (
                    customModuleAttainmentId of planStateObject.modules[module.id].selectedCustomModuleAttainmentIds;
                    track customModuleAttainmentId
                  ) {
                    <sis-plan-custom-module-attainment
                      [customModuleAttainment]="$any(planData.attainmentsById[customModuleAttainmentId])"
                      [planStateObject]="planStateObject"
                      [planData]="planData"
                      [uiStateObject]="uiStateObject"
                      [level]="level + 1"></sis-plan-custom-module-attainment>
                  }
                </div>
              }
            </div>
          }
          @if (isOpen && moduleStateObject.attainmentId) {
            <div>
              <sis-attainment-node-structure
                [attainmentNodes]="this.attainment?.nodes"
                [planStateObject]="planStateObject"
                [planData]="planData"
                [uiStateObject]="uiStateObject"
                [level]="level">
              </sis-attainment-node-structure>
            </div>
          }
        </div>
      </div>
    </li>
  </ul>
</div>
